export const env = {
  NODE_ENV: 'development',
  CLIENT_ID: 'neodash_local',
  URL: {
    HOST: 'http://localhost',
    NEOGIG: 'http://localhost:3000',
    NEOGIG_API: 'http://localhost:5100/api/v1',
    NEOGIG_IMAGE: 'http://localhost:3000/static/images',
    NEODASH_API: `http://localhost:5200`,
    REPORT_VIEWER: `http://reportviewer.qa.neogig.com.br`,
    CTRL_PANEL_API: `http://cp-api.qa.neogig.com.br`,
    IDENTITY_SERVER: `http://identity-server.qa.neogig.com.br`,
    WEBSOCKET: 'ws://dv.neogig.com.br/neodash_api/WsSocketHandler.ashx',
    PBIURL: `https://app.powerbi.com/`,
  }
};
